// A unified diff (git diff) split per file, for the change of a ticket (ADR-026 step 2): rows with their line numbers,
// plain text only.

export type DiffRow =
  | { kind: 'hunk'; text: string }
  | { kind: 'added' | 'removed' | 'context'; text: string; oldNo?: number; newNo?: number }
  | { kind: 'note'; text: string };

/** The unified diff split per file, keyed by path */
export function splitDiff(diff: string): Map<string, DiffRow[]> {
  const files = new Map<string, DiffRow[]>();
  let rows: DiffRow[] | null = null;
  let oldNo = 0;
  let newNo = 0;
  for (const line of diff.split('\n')) {
    if (line.startsWith('diff --git ')) {
      // `diff --git a/<path> b/<path>`: the b side, unless +++ says otherwise below
      const path = /^diff --git a\/(.*) b\/(.*)$/.exec(line)?.[2] ?? line.slice(11);
      rows = [];
      files.set(path, rows);
      continue;
    }
    if (!rows) continue;
    const hunk = /^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@(.*)$/.exec(line);
    if (hunk) {
      oldNo = Number(hunk[1]);
      newNo = Number(hunk[2]);
      rows.push({ kind: 'hunk', text: line });
    } else if (line.startsWith('Binary files')) {
      rows.push({ kind: 'note', text: 'Binary file: not shown.' });
    } else if (line.startsWith('\\')) {
      rows.push({ kind: 'note', text: line.slice(2) });
    } else if (!rows.some((r) => r.kind === 'hunk')) {
      continue; // index, mode and ---/+++ lines before the first hunk
    } else if (line.startsWith('+')) {
      rows.push({ kind: 'added', text: line.slice(1), newNo: newNo++ });
    } else if (line.startsWith('-')) {
      rows.push({ kind: 'removed', text: line.slice(1), oldNo: oldNo++ });
    } else if (line.startsWith(' ')) {
      rows.push({ kind: 'context', text: line.slice(1), oldNo: oldNo++, newNo: newNo++ });
    }
  }
  return files;
}
